import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class CheckLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true,
    };
  }

  componentDidMount() {
    const excludedPaths = ['signin-callback', '/login', '/logout', '/register', '/sso', '/main/off'];
    const currentPath = window.location.pathname + window.location.hash;

    if (!excludedPaths.some((path) => currentPath.includes(path))) {
      localStorage.setItem('savedRoute', currentPath);
    }

    StorageHandler.load(storageKeys.user).then((user) => this.setState({ loggedIn: user }));
  }

  render() {
    const { loggedIn } = this.state;
    return <div>{!loggedIn && <Redirect to="/main/off" />}</div>;
  }
}
